import { supabaseClient } from '../../../shared/utils/supabaseClient';

/**
 * Determines the user's role by querying the members table.
 * Sets localStorage so ProtectedRoute can gate routes correctly.
 * Returns { role, redirectTo }.
 *
 * Rule:
 *   members WHERE auth_user_id = userId AND status = 'active' → 'member'
 *   otherwise → 'admin'
 */
export const resolveUserRole = async (userId) => {
  console.log('🔍 resolveUserRole: querying members for auth_user_id =', userId);

  const { data: memberRecord, error: memberError } = await supabaseClient
    .from('members')
    .select('id')
    .eq('auth_user_id', userId)
    .eq('status', 'active')
    .maybeSingle();

  console.log('🔍 resolveUserRole result:', { memberRecord, memberError });

  const role = memberRecord ? 'member' : 'admin';
  const redirectTo = role === 'member' ? '/member/dashboard' : '/admin/dashboard';

  console.log(`🔍 resolveUserRole → role=${role}, redirectTo=${redirectTo}`);
  localStorage.setItem('userRole', role);

  supabaseClient.from('audit_logs').insert({
    event_category: 'auth',
    event_type: 'user_role_determined',
    actor_id: userId,
    actor_role: role,
    new_value: { role, redirectTo, member_id: memberRecord?.id || null },
    risk_level: 'low',
    flagged: false,
    timestamp: new Date().toISOString(),
  }).then(() => {});

  return { role, redirectTo };
};
